import createRouter, { generateRoutes } from '@/global/router'
import Login from '@/global/views/Login/index'
import store from '../store'

export const routeData = [
  {
    path: '/home',
    name: 'home',
    title: '首页面板',
    icon: 'icon-move',
    component: () => import('@/global/views/home-panel/index.vue'),
    meta: { platform: 'admin' }
  },
  {
    name: 'advertisePut',
    title: '广告投放',
    icon: 'icon-flag',
    children: [
      {
        path: '/advertiser',
        name: 'advertiser',
        title: '广告主管理',
        component: () => import('@/manager/views/advertiser/advertiser.vue'),
        includePaths: ['/addAdvertiser', '/editAdvertiser', '/auditing'],
        includePages: [
          {
            path: '/addAdvertiser',
            name: 'addAdvertiser',
            component: () => import('@/manager/views/advertiser/addAdvertiser.vue')
          },
          {
            path: '/editAdvertiser/:id',
            name: 'editAdvertiser',
            component: () => import('@/manager/views/advertiser/addAdvertiser.vue')
          },
          {
            path: '/auditing/:id',
            name: 'auditing',
            component: () => import('@/manager/views/advertiser/auditing.vue')
          }
        ]
      },
      {
        path: '/orderList/nofilter',
        name: 'orderList',
        title: '计划管理',
        meta: { platform: 'admin' },
        component: () => import('@/manager/views/advertise_put/order_list.vue'),
        includePaths: ['/orderAdd', '/orderOpr'],
        includePages: [
          {
            path: '/orderAdd/:media?',
            name: 'orderAdd',
            meta: { platform: 'admin' },
            component: () => import('@/manager/views/advertise_put/order_opr.vue')
          },
          {
            path: '/orderOpr/:id?/:type?/:media?',
            name: 'orderOpr',
            meta: { platform: 'admin' },
            component: () => import('@/manager/views/advertise_put/order_opr.vue')
          }
        ]
      },
      {
        path: '/advertiseList',
        name: 'advertiseList',
        title: '广告管理',
        meta: { platform: 'admin' },
        component: () => import('@/manager/views/advertise_put/advertise-list.vue'),
        // component: () => import('@/manager/views/advertise_put/advertise_list.vue'),
        includePaths: ['/advertiseOpr'],
        includePages: [
          {
            path: '/advertiseOpr/:adType/:type?/:id?',
            name: 'advertiseOpr',
            meta: { platform: 'admin' },
            // component: () => import('@/manager/views/advertise_put/advertise_opr.vue')
            component: () => import('@/manager/views/advertise_put/advertise-opr.vue')
          }
          // {
          //   path: '/advertiseAdd2/:adType/:type?/:id?',
          //   name: 'advertiseAdd2',
          //   component: () => import('@/manager/views/advertise_put/advertise_opr.vue')
          //   // component: () => import('@/manager/views/advertise_put/advertise-opr.vue')
          // }
        ]
      },
      {
        path: '/advertise/fallback',
        name: 'fallback',
        title: '打底广告',
        meta: { platform: 'admin' },
        component: () => import('@/manager/views/advertise_put/fallback-ad.vue'),
        includePaths: ['/fallbackAdd', '/fallbackEdit'],
        includePages: [
          {
            path: '/fallbackAdd',
            name: 'fallbackAdd',
            meta: { platform: 'admin' },
            component: () => import('@/manager/views/advertise_put/fallback-ad-edit.vue')
          },
          {
            path: '/fallbackEdit/:type/:id',
            name: 'fallbackEdit',
            meta: { platform: 'admin' },
            component: () => import('@/manager/views/advertise_put/fallback-ad-edit.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/staff',
    name: 'staff',
    title: '员工管理',
    icon: 'icon-move',
    component: () => import('@/manager/views/staff/index.vue'),
    includePages: [
      {
        path: '/staff/:type/:id?',
        name: 'addStaff',
        component: () => import('@/manager/views/staff/add.vue')
      }
    ]
  },
  {
    path: '/dataReport',
    name: 'dataReport',
    title: '数据报表',
    icon: 'icon-pie',
    meta: { platform: 'admin' },
    component: () => import('@/global/views/data_report.vue')
  },
  {
    path: '/audience',
    name: 'audience',
    title: '受众分析',
    icon: 'icon-pie',
    meta: { platform: 'admin' },
    component: () => import('@/global/views/audience-analysis/index.vue')
  },
  {
    name: 'financeManage',
    title: '财务管理',
    icon: 'icon-icon15',
    children: [
      {
        path: '/finDetails',
        name: 'finDetails',
        title: '财务明细',
        component: () => import('@/manager/views/financial/finDetails.vue'),
        includePaths: [],
        includePages: []
      },
      {
        path: '/auditFinancial',
        name: 'auditFinancial',
        title: '财务审核',
        component: () => import('@/manager/views/financial/auditFinancial.vue'),
        includePaths: ['/showAuditDetails', '/auditDetails'],
        includePages: [
          {
            name: 'showAuditDetails',
            path: '/showAuditDetails/:id',
            component: () => import('@/manager/views/financial/auditDetails.vue')
          },
          {
            name: 'auditDetails',
            path: '/auditDetails/:id',
            component: () => import('@/manager/views/financial/auditDetails.vue')
          }
        ]
      },
      {
        path: '/editFinancial',
        name: 'editFinancial',
        meta: { platform: 'admin' },
        title: '财务编辑',
        component: () => import('@/manager/views/financial/editFinancial.vue'),
        includePaths: ['/rebateFinancial'],
        includePages: [
          {
            name: 'rebateFinancial',
            path: '/rebateFinancial/:id',
            component: () => import('@/manager/views/financial/rebateFinancial.vue')
          }
        ]
      },
      {
        path: '/rebateCash',
        name: 'rebateCash',
        meta: { platform: 'admin' },
        title: '返货管理',
        component: () => import('@/manager/views/financial/rebateCash.vue')
      }
    ]
  },
  /* {
    name: 'userManage',
    title: '用户管理',
    icon: 'icon-zhanghaoguanli',
    children: [
      {
        path: '/characterList',
        name: 'characterList',
        title: '员工管理',
        component: () =>
          import('@/manager/views/user_manage/character_list.vue'),
        includePaths: ['/oprCharacter'],
        includePages: [
          {
            name: 'oprCharacter',
            path: '/oprCharacter/:id',
            component: () =>
              import('@/manager/views/user_manage/opr_character.vue')
          }
        ]
      },
      {
        path: '/userList',
        name: 'userList',
        title: '子账号管理',
        component: () => import('@/manager/views/user_manage/user_list.vue'),
        includePaths: ['/oprUser', '/oprAgencyUser'],
        includePages: [
          {
            name: 'oprUser',
            path: '/oprUser/:id',
            component: () => import('@/manager/views/user_manage/opr_user.vue')
          },
          {
            name: 'oprAgencyUser',
            path: '/oprAgencyUser/:id/:type',
            component: () =>
              import('@/manager/views/user_manage/opr_agency_user.vue')
          }
        ]
      }
    ]
  }, */
  {
    path: '/userList',
    name: 'nameList',
    title: '子账户管理',
    icon: 'icon-zhanghaoguanli',
    meta: { platform: 'admin' },
    component: () => import('@/manager/views/subAccount/user_list.vue'),
    includePaths: ['/oprUser', '/oprAgencyUser'],
    includePages: [
      {
        name: 'oprUser',
        path: '/oprUser/:id',
        meta: { platform: 'admin' },
        component: () => import('@/manager/views/subAccount/opr_user.vue')
      },
      {
        name: 'oprAgencyUser',
        meta: { platform: 'admin' },
        path: '/oprAgencyUser/:id/:userType?/:donewsStatus?/:type',
        component: () => import('@/manager/views/subAccount/opr_agency_user.vue')
      }
    ]
  },
  // {
  //   path: '/traffic',
  //   name: 'traffic',
  //   title: '内部流量管理',
  //   icon: 'icon-flag',
  //   includePaths: ['/editTraffic', '/showTraffic'],
  //   component: () => import('@/manager/views/traffic/trafficManage.vue'),
  //   includePages: [
  //     {
  //       name: 'editTraffic',
  //       path: '/editTraffic',
  //       component: () => import('@/manager/views/traffic/editTraffic.vue')
  //     },
  //     {
  //       name: 'showTraffic',
  //       path: '/showTraffic',
  //       component: () => import('@/manager/views/traffic/showTraffic.vue')
  //     }
  //   ]
  // },
  {
    path: 'traffic',
    name: 'traffic',
    title: '内部流量管理',
    icon: 'icon-flag',
    meta: { platform: 'admin' },
    children: [
      {
        path: '/cutPreview',
        name: 'cutPreview',
        title: '广告裁切预览',
        meta: { platform: 'admin' },
        component: () => import('@/manager/views/traffic/cutPreview.vue')
      }
    ]
  },
  {
    path: 'tool',
    name: 'tool',
    title: '工具',
    icon: 'icon-flag',
    meta: { platform: 'admin' },
    children: [
      {
        name: 'operationLog',
        path: '/operationLog',
        meta: { platform: 'admin' },
        title: '操作日志',
        component: () => import('@/global/views/tool/operationLog.vue')
      }
    ]
  }
]
let routeDataFilter = routeData.filter(item => {
  // eslint-disable-next-line no-undef
  return item.name === 'audience' && VUE_APP_ENV === 'online' ? false : item
})
const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { platform: 'admin', path: 'advertiser' }
  },
  {
    path: '/',
    meta: { platform: 'admin' },
    component: () => import('@/manager/views/main.vue'),
    children: generateRoutes(routeDataFilter, true)
  }
]
export default createRouter({ base: '/manager/', routes, routeData: routeDataFilter }, store, 'admin')
